import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Table,
} from "reactstrap";

import { provincesRepo } from "data/repositories/provincesRepo";
import { themes } from "data/dbsSeed";

function themeColor(theme) {
  switch (theme) {
    case "Nature":
      return "success";
    case "History":
      return "warning";
    case "Food":
      return "info";
    case "Adventure":
      return "danger";
    case "Sea":
      return "primary";
    case "Culture":
      return "default";
    default:
      return "secondary";
  }
}

export default function ProvincesList() {
  const [items, setItems] = useState([]);

  const load = () => {
    setItems(provincesRepo.list());
  };

  useEffect(() => {
    load();
  }, []);

  const byId = useMemo(() => {
    const map = new Map();
    for (const p of items) map.set(p.id, p);
    return map;
  }, [items]);

  const onDelete = (id) => {
    const p = byId.get(id);
    const ok = window.confirm(`${p?.name || id} silinsin mi?`);
    if (!ok) return;
    provincesRepo.remove(id);
    load();
  };

  return (
    <>
      <div className="header bg-gradient-info pb-6 pt-5 pt-md-7">
        <Container fluid>
          <div className="header-body">
            <Row className="align-items-center py-4">
              <Col lg="6" xs="7">
                <h6 className="h2 text-white d-inline-block mb-0">İller (CRUD)</h6>
              </Col>
              <Col lg="6" xs="5" className="text-right">
                <Button tag={Link} to="/admin/content/provinces/new" color="secondary" size="sm">
                  Yeni il
                </Button>
              </Col>
            </Row>
          </div>
        </Container>
      </div>

      <Container className="mt--6" fluid>
        <Row>
          <Col>
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Liste</h3>
              </CardHeader>
              <CardBody>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">ID</th>
                      <th scope="col">Ad</th>
                      <th scope="col">Slogan</th>
                      <th scope="col">Temalar</th>
                      <th scope="col" className="text-right">İşlem</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((p) => (
                      <tr key={p.id}>
                        <td>{p.id}</td>
                        <td>{p.name}</td>
                        <td style={{ maxWidth: 360 }}>
                          <span className="text-muted">{p.slogan}</span>
                        </td>
                        <td>
                          {(p.themes || []).filter((t) => themes.includes(t)).map((t) => (
                            <Badge key={`${p.id}-${t}`} color={themeColor(t)} pill className="mr-1">
                              {t}
                            </Badge>
                          ))}
                        </td>
                        <td className="text-right">
                          <Button
                            tag={Link}
                            to={`/admin/content/provinces/${p.id}`}
                            color="primary"
                            size="sm"
                            className="mr-2"
                          >
                            Düzenle
                          </Button>
                          <Button color="danger" size="sm" onClick={() => onDelete(p.id)}>
                            Sil
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                {!items.length ? (
                  <div className="text-center text-muted py-4">Henüz il yok. “Yeni il” ile ekleyin.</div>
                ) : null}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
